import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Biology = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/learning-app.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Facilities" breadEnd="Learning Approach" breadMid="Biology Lab" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <h4 className="color-red">Biology</h4>
                            <div class="lab-heading mb-4">
                                <div class="lab-btn" id="mb-lab-btn"><span>Labs</span></div>
                                <ul class="labs-list">
                                    <li><a class="" href="/mathmatics">Mathematics</a></li>
                                    <li><a class="" href="/physics">Physics</a></li>
                                    <li><a class="inc-tlink-active" href="/biology">Biology</a></li>
                                    <li><a class="" href="/chemistry">Chemistry</a></li>
                                    <li><a class="" href="/language">Language</a></li>
                                    <li><a class="" href="/computer">Computer</a></li>
                                    <li><a class="" href="/robotics">Robotics</a></li>
                                    <li><a class="" href="/hands-on-studio">Hands On Studio</a></li>
                                    <li><a class="" href="/psychology">Psychology</a></li>
                                    <li><a class="" href="/counseling-sen">Counseling &amp; Sen </a></li>
                                </ul>
                            </div>
                            {/* <h5 className="text-center color-red mb-4"><i>Verbal communication is temporal and easily forgotten, but written reports exist for long periods and yield long-term benefits for the author and others.</i></h5> */}
                            <LazyLoad><img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/science-lab1.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Our Biology Laboratory is well equipped with required infrastructure and equipments .The lab can accommodate 40 -50 learners at a time for comfortable conduction of experiments.</p>
                            <p>To ensure the top quality and CBSE demand for practicals , our lab is operational with the best chemicals, reagents, slides, models, charts, 3D Models, specimens, microscopes, glassware etc. All learners are given an opportunity to conduct experiments individually using high resolution, good quality compound microscopes and other equipments and. Instruments like weighing balance are digital to ensure best results.</p>
                            <p>Keeping in view the well being and safety of our learners , the Laboratory is constructed with heat sensors for detecting heat and has two doors for entry and exit to ensure safer and smoother movement incase of any contingency . Experiments are always conducted under a vigilant supervision of two teachers and a Lab assistant to facilitate & guide the learners.</p>
                            <p>The Lab is also equipped with surplus charts & models to demonstrate the learners during the regular teaching learning process & has an attached store to store glass wares and other harmful reagents.</p>
                        </div>

                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default Biology